import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

import Rotas from './routes/routes.jsx';

function App() {
  return (
    <div className="App">
      <Rotas />
    </div>
  );
}

export default App;
